import packetComponent from './packet.component';
import routes from './packet.routes';
import packetDeleteDialogComponent from './packet-delete-dialog/packet-delete-dialog.component';
import packetDeleteSuccessDialogComponent from './packet-delete-success-dialog/packet-delete-success-dialog.component';
import packetDeleteImmediateSuccessDialogComponent from './packet-delete-immediate-success-dialog/packet-delete-immediate-success-dialog.component';
import packageChurnRetentionSuccessDialog from './package-churn-retention-success-dialog/package-churn-retention-success-dialog.component';
export default angular
  .module('fizyweb.paycell.packet', [])
  .component('fizyPaycellPacket', packetComponent)
  .component('fizyPaycellPacketDeleteDialog', packetDeleteDialogComponent)
  .component('fizyPaycellPacketDeleteSuccessDialog', packetDeleteSuccessDialogComponent)
  .component('fizyPaycellImmediatePacketDeleteSuccessDialog', packetDeleteImmediateSuccessDialogComponent)
  .component('fizyPaycellPackageChurnRetentionSuccessDialog', packageChurnRetentionSuccessDialog)
  .config(routes).name;



// WEBPACK FOOTER //
// src/app/packet/packet.module.ts